export default "__VITE_ASSET__hap77x9Z__"